(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bonanza-collection-banner"]) return;
  try {
    
  if (!customElements.get('bonanza-collection-banner')) {
    customElements.define('bonanza-collection-banner', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.index = 0;
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.paused = this.motion.matches || this.dataset.editor === 'true';
        this.hovered = false;
        this.focused = this.contains(document.activeElement);
        this.pauseButton = this.querySelector('[data-pause]');
        this.counter = this.querySelector('[data-counter]');
        this.interval = Math.max(3000, Math.min(12000, Number(this.dataset.interval) || 6000));
        this.show(0);
        this.addEventListener('shopify:block:select', (event) => {
          const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
          if (index < 0) return;
          this.paused = true;
          this.show(index);
          this.schedule();
        }, options);
        if (this.slides.length < 2) return;
        this.querySelector('[data-controls]').hidden = false;
        this.querySelector('[data-previous]').addEventListener('click', () => this.step(-1), options);
        this.querySelector('[data-next]').addEventListener('click', () => this.step(1), options);
        this.pauseButton?.addEventListener('click', () => { this.paused = !this.paused; this.schedule(); }, options);
        this.addEventListener('mouseenter', () => { this.hovered = true; this.schedule(); }, options);
        this.addEventListener('mouseleave', () => { this.hovered = false; this.schedule(); }, options);
        this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, options);
        this.addEventListener('focusout', (event) => {
          this.focused = this.contains(event.relatedTarget);
          this.schedule();
        }, options);
        this.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          this.step(event.key === 'ArrowRight' ? 1 : -1);
        }, options);
        this.addEventListener('touchstart', (event) => {
          this.touch = { x: event.changedTouches[0].clientX, y: event.changedTouches[0].clientY };
        }, { ...options, passive: true });
        this.addEventListener('touchend', (event) => {
          if (!this.touch) return;
          const x = event.changedTouches[0].clientX - this.touch.x;
          const y = event.changedTouches[0].clientY - this.touch.y;
          if (Math.abs(x) > 50 && Math.abs(x) > Math.abs(y)) this.step(x < 0 ? 1 : -1);
          this.touch = null;
        }, { ...options, passive: true });
        document.addEventListener('visibilitychange', () => this.schedule(), options);
        this.motion.addEventListener('change', () => {
          if (this.motion.matches) this.paused = true;
          this.schedule();
        }, options);
        this.schedule();
      }
      show(index) {
        if (!this.slides.length) return;
        this.index = (index + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, i) => { slide.hidden = i !== this.index; });
        const current = this.querySelector('[data-current]');
        if (current) current.textContent = String(this.index + 1);
      }
      step(direction) {
        this.paused = true;
        this.schedule();
        this.show(this.index + direction);
      }
      schedule() {
        clearTimeout(this.timer);
        this.timer = null;
        const running = this.dataset.autoplay === 'true' && !this.paused && !this.hovered && !this.focused && !document.hidden && this.slides.length > 1;
        if (this.counter) this.counter.setAttribute('aria-live', running ? 'off' : 'polite');
        if (this.pauseButton) this.pauseButton.textContent = this.paused ? this.pauseButton.dataset.playLabel : this.pauseButton.dataset.pauseLabel;
        if (running) this.timer = setTimeout(() => {
          this.show(this.index + 1);
          this.schedule();
        }, this.interval);
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        this.controller?.abort();
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bonanza-halloween-countdown"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bonanza-halloween-countdown')) {
    customElements.define('bonanza-halloween-countdown', class extends HTMLElement {
      connectedCallback() {
        this.end = Date.parse(this.dataset.end);
        this.timer = this.querySelector('[data-timer]');
        this.countdownTitle = this.querySelector('[data-countdown-title]');
        this.happyTitle = this.querySelector('[data-halloween-title]');
        this.status = this.querySelector('[data-status]');
        this.fields = ['days', 'hours', 'minutes', 'seconds'].map(unit => this.querySelector('[data-' + unit + ']'));
        if (!Number.isFinite(this.end)) {
          this.hidden = true;
          return;
        }
        this.update();
        if (!this.hidden) this.interval = window.setInterval(() => this.update(), 1000);
      }

      disconnectedCallback() {
        window.clearInterval(this.interval);
      }

      update() {
        const now = Date.now();
        if (now >= this.end + 86400000) {
          this.hidden = true;
          window.clearInterval(this.interval);
          return;
        }
        const remaining = Math.max(0, Math.ceil((this.end - now) / 1000));
        const finished = remaining === 0;
        this.timer.hidden = finished;
        this.countdownTitle.hidden = finished;
        this.happyTitle.hidden = !finished;
        if (finished && this.status.textContent !== this.happyTitle.textContent) {
          this.status.textContent = this.happyTitle.textContent;
        }
        const values = [Math.floor(remaining / 86400), Math.floor(remaining % 86400 / 3600), Math.floor(remaining % 3600 / 60), remaining % 60];
        this.fields.forEach((field, index) => {
          const value = String(values[index]).padStart(2, '0');
          if (field.textContent !== value) field.textContent = value;
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
